import LocalizedMenu from './LocalizedMenu';

export default LocalizedMenu;
